import { useQuery } from '@tanstack/react-query';
import FileDownload from 'js-file-download';

import { queries } from '../../../../common/api/queryKeys/queries';
import { formatDateTime } from '../../../../common/helpers/formatDateTime.helper';
import { formatUser } from '../../../../common/helpers/formatUser.helper';

const useMessagesForOfferId = (offerId) => {
    return useQuery({
        ...queries.offers.detail(offerId)._ctx.offerMessages,
        enabled: false,
    });
};

export const useMessagesExport = (offerId) => {
    const messagesForOfferQuery = useMessagesForOfferId(offerId);

    const createExportMessage = (message) => {
        let messageTxt = '';
        messageTxt += '[' + formatDateTime({ date: message.dateCreated, format: 'MMM d, yyyy h:mm a' }) + '] ';
        if (message.senderType !== 'SYSTEM' && message.user) {
            messageTxt += formatUser(message.user) + ': ';
        }
        messageTxt += message.message.replace('<strong>', '').replace('</strong>', '');
        return messageTxt;
    };

    const downloadMessages = async (offerNumber) => {
        const result = await messagesForOfferQuery.refetch();
        const messages = result.data;

        const messageTxtArray = messages.map((message) => {
            return createExportMessage(message);
        });

        const messageBlob = new Blob([messageTxtArray.join('\r\n')], {
            type: 'application/octet-stream',
        });

        FileDownload(messageBlob, `${offerNumber}_messages.txt`);
    };

    return {
        downloadMessages,
    };
};
